/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PayPalPspR = t.interface({
  avgFee: t.number,

  codiceAbi: t.string,

  idPsp: t.string,

  maxFee: t.Integer,

  onboard: t.boolean,

  privacyUrl: t.string,

  ragioneSociale: t.string
});

// optional attributes
const PayPalPspO = t.partial({});

export const PayPalPsp = t.intersection([PayPalPspR, PayPalPspO], "PayPalPsp");

export type PayPalPsp = t.TypeOf<typeof PayPalPsp>;
